import React from "react";

import { DataTableColumn } from "../../../components/ui/data-table";
import { ProductCategory } from "./types";
import { money } from "./utils";

export type CurationTableRow = {
  key: number;
  rank: number;
  product_name: string;
  category: ProductCategory;
  quantity: number;
  unit_price: number;
  total_price: number;
  coupang_reference_price: number;
  coupang_search_url: string;
  reference_source: string;
  reason: string;
};

const baseColumns: DataTableColumn<CurationTableRow>[] = [
  { title: "번호", dataIndex: "rank", width: 70, align: "center" },
  { title: "품목명", dataIndex: "product_name" },
  {
    title: "카테고리",
    dataIndex: "category",
    render: (v: ProductCategory) => (v === "beverage" ? "음료" : "스낵"),
    width: 110,
    align: "center",
  },
  {
    title: "추천 수량",
    dataIndex: "quantity",
    align: "right",
    width: 120,
    sortable: true,
  },
  {
    title: "예상 단가",
    dataIndex: "unit_price",
    align: "right",
    render: (v: number) => money(v),
    sortable: true,
    width: 140,
  },
  {
    title: "외부 참고가",
    dataIndex: "coupang_reference_price",
    align: "right",
    render: (v: number) => money(v),
    sortable: true,
    width: 150,
  },
  {
    title: "예상 금액",
    dataIndex: "total_price",
    align: "right",
    render: (v: number) => money(v),
    sortable: true,
    width: 140,
  },
  {
    title: "참조 소스",
    dataIndex: "reference_source",
    width: 120,
    align: "center",
  },
  {
    title: "외부 링크",
    dataIndex: "coupang_search_url",
    width: 120,
    align: "center",
    render: (url: string) =>
      url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-blue-600 underline"
        >
          검색
        </a>
      ) : (
        "-"
      ),
  },
  { title: "추천 근거", dataIndex: "reason" },
];

export const CURATION_TABLE_COLUMNS: DataTableColumn<CurationTableRow>[] =
  baseColumns;

export const CUSTOMER_CURATION_TABLE_COLUMNS: DataTableColumn<CurationTableRow>[] =
  [
    { title: "번호", dataIndex: "rank", width: 70, align: "left" },
    { title: "품목명", dataIndex: "product_name", width: 240, align: "left" },
    {
      title: "카테고리",
      dataIndex: "category",
      render: (v: ProductCategory) => (v === "beverage" ? "음료" : "스낵"),
      width: 110,
      align: "left",
    },
    {
      title: "추천 수량",
      dataIndex: "quantity",
      align: "left",
      width: 120,
      sortable: true,
    },
    {
      title: "외부 참고가",
      dataIndex: "coupang_reference_price",
      align: "left",
      render: (v: number) => money(v),
      sortable: true,
      width: 130,
    },
    {
      title: "예상 금액",
      dataIndex: "total_price",
      align: "left",
      render: (v: number) => money(v),
      sortable: true,
      width: 130,
    },
    {
      title: "참조 소스",
      dataIndex: "reference_source",
      width: 110,
      align: "left",
    },
    {
      title: "외부 링크",
      dataIndex: "coupang_search_url",
      width: 110,
      align: "left",
      render: (url: string) =>
        url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-blue-600 underline"
          >
            검색
          </a>
        ) : (
          "-"
        ),
    },
    { title: "추천 근거", dataIndex: "reason", width: 320, align: "left" },
  ];
